module.exports = __webpack_public_path__ + "res/media/Crosscert_Browser_PLM_Guide.pdf";